export const qrStand = 'qr-stand';

export const oraclePayment = 'qr-oracle';

export const payLater = 'pay-later';

export const splitMenuPaymentType = 'split.menu';

export const splitAmountPaymentType = 'split.amount';

export const dynamicQr = 'dynamic-qr';

export const COUNTRY_CODE = 'countryCode';

export const CURRENCY_CODE = 'currencyCode';

export const GIRO_PAY = 'giropay';

export const IDEAL = 'ideal';

export const APPLE_PAY = 'Apple Pay';

export const GOOGLE_PAY = 'Google Pay';

export const EUR_CURRENCY = 'EUR';

export const MINIMUM_CASHBACK = 0.5;

export const PAYMENT_CHANNEL_WEB = 'web';

export enum PAYMENT_STATUS {
  FAILED = 'failed',
  SUCCEEDED = 'succeeded',
  PENDING = 'pending',
}

export enum TIPE_PAYMENT_TYPE {
  CUSTOM_TIP = 3,
}

export enum PAYMENT_METHODS {
  GOOGLE_PAY = 'GOOGLE_PAY',
  APPLE_PAY = 'APPLE_PAY',
  CARD = 'CARD',
  GIROPAY = 'GIROPAY',
  IDEAL = 'IDEAL',
  PAYPAL = 'PAYPAL',
  PAY_BY_BANK = 'PAY_BY_BANK',
  TWINT = 'TWINT',
  WERO = 'WERO',
  EPS = 'EPS',
}

export enum STRIPE_PAYMENT_METHODS {
  CARD = 'card',
  IDEAL = 'ideal',
  GIROPAY = 'giropay',
}

export enum ADYEN_PAYMENT_METHODS {
  GIROPAY = 'giropay',
  IDEAL = 'ideal',
  PAYPAL = 'paypal',
  GOOGLEPAY = 'googlepay',
  PAY_BY_BANK = 'paybybank',
  TWINT = 'twint',
  WERO = 'wero',
  EPS = 'eps',
}
